// src/components/LeaveCallModal.jsx
import React, { useState } from "react";
import styles from "./DeactivateModal.module.css";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { deactivateApi } from "../Http/http";

export default function DeactivateModal({ open, setOpen }) {
    const navigate = useNavigate();
    const [unsubscribeLoading, setUnsubscribeLoading] = useState(false);
    const deactivateUser = async () => {
        try {
            setUnsubscribeLoading(true);
            const response = await axios.post(deactivateApi, {
                msisdn: Cookies.get("msisdn")
            })
            setUnsubscribeLoading(false);
            setOpen(false);
            Cookies.remove("msisdn");
            toast.success("Unsubscribed Successfully!");
            navigate("/");
        } catch (error) {
            setUnsubscribeLoading(false);
            toast.success("Something Went Wrong!");
            console.log(error, 'error');
        }
    }
    return (
        <div className={styles.backdrop}>
            <div className={styles.card}>
                <h3>Unsubscribe from Service?</h3>
                <p>Are you sure you want to unsubscribe from the service?</p>
                {unsubscribeLoading ? <p>Please Wait - Unsubscribing....</p> : (
                    <div className={styles.actions}>
                        <button onClick={()=>setOpen(false)}>No</button>
                        <button onClick={deactivateUser}>Yes</button>
                    </div>
                )}
            </div>
        </div>
    );
}
